import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "panel", "backdrop", "openIcon", "closeIcon"]

  connect() {
    this._bindEsc = (e) => {
      if (e.key === "Escape") this.close()
    }
    this.close() // ensure closed state on load
  }

  disconnect() {
    document.removeEventListener("keydown", this._bindEsc)
    document.documentElement.classList.remove("overflow-hidden")
  }

  toggle() {
    if (this.isOpen) this.close()
    else this.open()
  }

  open() {
    this.isOpen = true
    // Enable overlay interactions and animate panel in
    this.menuTarget.classList.remove("pointer-events-none", "opacity-0")
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.classList.add("translate-x-0")

    // Icons
    this.openIconTargets?.forEach(el => el.classList.add("hidden"))
    this.closeIconTargets?.forEach(el => el.classList.remove("hidden"))

    // Prevent background scroll
    document.documentElement.classList.add("overflow-hidden")
    document.addEventListener("keydown", this._bindEsc)
  }

  close() {
    this.isOpen = false
    // Animate panel out and disable interactions
    this.panelTarget.classList.add("translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    this.menuTarget.classList.add("pointer-events-none", "opacity-0")

    // Icons
    this.openIconTargets?.forEach(el => el.classList.remove("hidden"))
    this.closeIconTargets?.forEach(el => el.classList.add("hidden"))

    // Restore scroll
    document.documentElement.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._bindEsc)
  }
}
